import { useState } from "react";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { useGetAdherent } from "../../../hooks/useGetAdherent";
import {
  getListeProgramme,
  setListeGarantiesSelectedProgramme,
  setSelectedProgramme,
} from "../../../redux/ProgrammeRedux";
import { RootState } from "../../../redux/reducers";
import { Programme } from "../../../services/Api/swagger";
import { buildTabs } from "../helpers";

export const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;

export interface TabItem {
  index: number;
  title: string;
  value: string;
}
export const useProgrammeContrat = (selectedAdhesion) => {
  const dispatch = useDispatch();
  const { listeAdhesions } = useGetAdherent();

  const listeProgrammes = useReduxSelector((state) => getListeProgramme(state));

  const [tabs, setTabs] = useState<TabItem[]>();

  const handleChangeProgramme = (code) => {
    const findProgramme: Programme | undefined =
      listeProgrammes && listeProgrammes.find((pgm) => pgm.code === code);

    if (findProgramme) {
      findProgramme.listeProduits &&
        findProgramme.listeProduits[0] &&
        findProgramme.listeProduits[0].listeGaranties &&
        dispatch(
          setListeGarantiesSelectedProgramme(
            findProgramme.listeProduits[0].listeGaranties
          )
        );
      dispatch(setSelectedProgramme(findProgramme));
      setTabs(buildTabs(findProgramme, selectedAdhesion));
    }
  };

  return { listeAdhesions, handleChangeProgramme, tabs };
};
